import styled from 'styled-components'

import { colors } from '../../../../styles/colors'

const ActivityEm = styled.em`
	// color: ${colors.activity};
`

export default ActivityEm
